import _classCallCheck from "/vercel/path0/node_modules/.pnpm/@babel+runtime@7.15.4/node_modules/@babel/runtime/helpers/esm/classCallCheck";
import _createClass from "/vercel/path0/node_modules/.pnpm/@babel+runtime@7.15.4/node_modules/@babel/runtime/helpers/esm/createClass";
import _inherits from "/vercel/path0/node_modules/.pnpm/@babel+runtime@7.15.4/node_modules/@babel/runtime/helpers/esm/inherits";
import _possibleConstructorReturn from "/vercel/path0/node_modules/.pnpm/@babel+runtime@7.15.4/node_modules/@babel/runtime/helpers/esm/possibleConstructorReturn";
import _getPrototypeOf from "/vercel/path0/node_modules/.pnpm/@babel+runtime@7.15.4/node_modules/@babel/runtime/helpers/esm/getPrototypeOf";
import _taggedTemplateLiteral from "/vercel/path0/node_modules/.pnpm/@babel+runtime@7.15.4/node_modules/@babel/runtime/helpers/esm/taggedTemplateLiteral";

var _templateObject, _templateObject2, _templateObject3;

function _createSuper(Derived) { var hasNativeReflectConstruct = _isNativeReflectConstruct(); return function _createSuperInternal() { var Super = _getPrototypeOf(Derived), result; if (hasNativeReflectConstruct) { var NewTarget = _getPrototypeOf(this).constructor; result = Reflect.construct(Super, arguments, NewTarget); } else { result = Super.apply(this, arguments); } return _possibleConstructorReturn(this, result); }; }

function _isNativeReflectConstruct() { if (typeof Reflect === "undefined" || !Reflect.construct) return false; if (Reflect.construct.sham) return false; if (typeof Proxy === "function") return true; try { Boolean.prototype.valueOf.call(Reflect.construct(Boolean, [], function () {})); return true; } catch (e) { return false; } }

import { AiDeleteQuestionChangeStrategy } from '../../../../bases';
import { AnswerItem } from '../components';
import styled from '@xstyled/styled-components';
import { getSize } from '@lib/common';
import { MathEnabledTextComponent } from '@lib/common';
import { jsx as _jsx } from "react/jsx-runtime";
var StyledAnswerContainer = styled.div(_templateObject || (_templateObject = _taggedTemplateLiteral(["\n  width: 100%;\n  margin-top: ", ";\n"])), getSize('padding12'));
var StyledAnswerGroup = styled.div(_templateObject2 || (_templateObject2 = _taggedTemplateLiteral(["\n  display: flex;\n  flex-direction: column;\n  gap: ", ";\n  width: 100%;\n"])), getSize('padding12'));
var StyledAnswerDescriptionBefore = styled(MathEnabledTextComponent)(_templateObject3 || (_templateObject3 = _taggedTemplateLiteral(["\n  font-size: ", ";\n  font-weight: 500;\n  color: #ef4444;\n  text-decoration: line-through;\n  background-color: #fef2f2;\n  padding: 0 4px;\n  border-radius: 2px;\n  line-height: ", ";\n  *,\n  span,\n  p {\n    text-decoration: line-through !important;\n    color: #ef4444 !important;\n    display: inline;\n  }\n"])), getSize('typo16'), getSize('padding24'));
export var MultipleChoiceDeleteQuestionStrategy = /*#__PURE__*/function (_AiDeleteQuestionChan) {
  _inherits(MultipleChoiceDeleteQuestionStrategy, _AiDeleteQuestionChan);

  var _super = _createSuper(MultipleChoiceDeleteQuestionStrategy);

  function MultipleChoiceDeleteQuestionStrategy(context) {
    _classCallCheck(this, MultipleChoiceDeleteQuestionStrategy);

    return _super.call(this, context);
  }

  _createClass(MultipleChoiceDeleteQuestionStrategy, [{
    key: "renderAnswers",
    value: function renderAnswers() {
      var before = this.context.before;
      return /*#__PURE__*/_jsx(StyledAnswerContainer, {
        children: /*#__PURE__*/_jsx(StyledAnswerGroup, {
          children: before === null || before === void 0 ? void 0 : before.answers.map(function (answer, index) {
            var _answer$description;

            var isSelected = before === null || before === void 0 ? void 0 : before.correctAnswers.some(function (ca) {
              return ca.answerId === answer.id.toString();
            });
            return /*#__PURE__*/_jsx(AnswerItem, {
              index: index,
              values: {
                description: /*#__PURE__*/_jsx(StyledAnswerDescriptionBefore, {
                  value: (_answer$description = answer.description) !== null && _answer$description !== void 0 ? _answer$description : ''
                }),
                isSelected: isSelected
              }
            }, answer.id.toString());
          })
        })
      });
    }
  }]);

  return MultipleChoiceDeleteQuestionStrategy;
}(AiDeleteQuestionChangeStrategy);